import React from "react";
import Checkbox from '../checkbox/checkbox';
import styles from './checkbox-list.module.scss';

interface classesCheckboxList {
  checkboxList?: string
  title?: string
  label?: string
  input?: string
  checkmark?: string
  checkbox?: string
}

interface CheckboxItem<T> {
  key: T;
  label: string;
}

interface CheckboxListProps<T> {
  items: CheckboxItem<T>[];
  selectedValues: T[];
  onItemChange: (key: T) => void;
  title?: string;
  className?: string;
  classes?: classesCheckboxList;
  size?: 'large' | 'medium'
}

const CheckboxList= <T extends number | string,>({
                                                   items,
                                                   selectedValues,
                                                   onItemChange,
                                                   title,
                                                   className,
                                                   classes = {},
                                                   size
}:CheckboxListProps<T>) => {
  return (
      <div className={`${styles.checkboxList} ${classes?.checkboxList || ''} ${className || ''}`}>
        {title && <div className={`${styles.title} ${classes?.title}`}>{title}</div>}
        {items.map((item) => (
            <Checkbox
                key={item.key}
                label={item.label}
                checked={selectedValues.includes(item.key)}
                onChange={() => onItemChange(item.key)}
                classes={{
                  checkbox: classes.checkbox,
                  label: classes.label,
                  input: classes.input,
                  checkmark: classes.checkmark,
                }}
                size={size}
            />
        ))}
      </div>
  );
};

export default CheckboxList;
